export const IBAN_MAX_LENGTH = 29;

export const QR_CODE_TIME: number = 180;

export const ALLOWED_ORIGINS = [
  window.location.origin,
  'https://portal.eximb.com',
  'https://portal-t.eximb.com',
  'https://diia.app',
];

export const ALLOWED_PROTOCOLS = ['blob:', 'http:', 'https:'];

export const UKRAINIAN_OPERATOR_CODES = [
  '067',
  '068',
  '096',
  '097',
  '098',
  '077',
  '050',
  '066',
  '095',
  '099',
  '075',
  '063',
  '073',
  '093',
  '089',
  '094',
  '091',
  '092',
];

export const ALLOWED_TLDs = ['.ua', '.com', '.net', '.org', '.co', '.io', '.uk', '.de', '.us'];

export const AGGRESSOR_COUNTRY_CODES = {
  BELARUS: '112',
  RUSSIAN_FEDERATION: '643',
};

export const IDLE_TIMEOUT = 25 * 60 * 1000;
export const WARNING_DURATION = 5 * 60 * 1000;
export const VITE_PRELOAD_LOADED = 'vite-preload-reloaded';
export const ACTIVITY_EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'scroll',
  'touchstart',
  'wheel',
];

import { CLIENT_TYPES_ID, ClientTypes } from './clientTypes';

export const currencyCodes = {
  HRYVNIA: 980,
  US_DOLLAR: 840,
  EURO: 978,
  POUND_STERLING: 826,
  FORINT: 348,
  YEN: 392,
  NORWEGIAN_KRONE: 578,
  ZLOTY: 985,
  SWEDISH_KRONA: 752,
  AUSTRALIAN_DOLLAR: 36,
  CANADIAN_DOLLAR: 124,
  SWISS_FRANC: 756,
  YUAN: 156,
  CZECH_KORUNA: 203,
  DANISH_KRONE: 208,
  GOLD: 959,
};

export const сontragentTypeValues = {
  CONTRAGENT_SOLE_TRADER: {
    value: CLIENT_TYPES_ID[ClientTypes.SOLE_TRADER] || '',
    label: 'Фізична особа–підприємець',
  },
  CONTRAGENT_LEGAL_RESIDENT: {
    value: CLIENT_TYPES_ID[ClientTypes.LEGAL_RESIDENT] || '',
    label: 'Юридична особа-резидент',
  },
  CONTRAGENT_ASSET_MANAGER: {
    value: CLIENT_TYPES_ID[ClientTypes.ASSET_MANAGER] || '',
    label: 'Розпорядник',
  },
};

export const citiesWithoutDistricts = {
  KYIV_CITY_CODE: 191919,
  KYIV_REGION_CODE: 26,
  SEVASTOPOL_CITY_CODE: 191931,
  SEVASTOPOL_REGION_CODE: 27,
};

export const SPECIAL_CITIES_WITHOUT_DISTRICTS = [
  citiesWithoutDistricts.KYIV_CITY_CODE.toString(),
  citiesWithoutDistricts.KYIV_REGION_CODE.toString(),
  citiesWithoutDistricts.SEVASTOPOL_CITY_CODE.toString(),
  citiesWithoutDistricts.SEVASTOPOL_REGION_CODE.toString(),
];

export const blockedDomains = [
  'yandex.ru',
  'yandex.ua',
  'mail.ru',
  'mail.ua',
  'inbox.ru',
  'list.ru',
  'bk.ru',
  'rambler.ru',
  'russianpost.ru',
  'ya.ru',
  'yandex.com',
  'yandex.by',
  'yandex.kz',
  'tut.by',
  'mail.by',
  'inbox.by',
];

export const otpValues = {
  otp: 6,
  maxAttempts: 4,
};

export const UKRAINE_CODE = '804';
export const USA_CODE = '840';
